/**
 * Principle-owned product taxonomy that feature gates branch on. Decoupled
 * from Stripe's `prod_*` IDs because those vary per environment and can be
 * renamed in the Stripe dashboard with no code change.
 *
 * Adding a key requires a matching entry in every env product catalog and
 * an update to `ADD_ON_BUNDLE_MAP` if the product participates in bundle expansion.
 */
export enum AddOnKey {
  AiImagingAnalysis = 'ai-imaging-analysis',
  AiReceptionist = 'ai-receptionist',
  AiScribe = 'ai-scribe',
}
